import { Dialog as ReactDialog } from "@certn/cascadia-react/components/modal/Dialog";
import { memo } from "react";

import { CascadiaDialogProps } from "./types";

export const Dialog = memo(function (props: CascadiaDialogProps) {
  return <ReactDialog {...props} />;
});
